module.exports = __webpack_public_path__ + "img/trashcan.36e3febc.svg";